const ResetModal = function () {
  //this.editItem.modal.hide()
  this.editItem.resetForm()
}

export default ResetModal
